module.exports = __webpack_public_path__ + "static/media/RHInSwing.784abb5c.svg";